
  /* Eenmalige eventdelegatie: werkt ook met meerdere Custom Liquid-collecties. */
  if (!window.cjDuffleCarouselBound) {
    window.cjDuffleCarouselBound = true;
    document.addEventListener('click', function (event) {
      const button = event.target.closest('.cj-duffle__arrow');
      if (!button) return;
      const section = button.closest('.cj-duffle');
      const track = section && section.querySelector('.cj-duffle__track');
      if (!track || !track.firstElementChild) return;
      const cardWidth = track.firstElementChild.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const direction = Number(button.getAttribute('data-cj-duffle-step'));
      track.scrollBy({
        left: direction * (cardWidth + gap),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    });
  }
